import React from 'react'
import SbEditable from 'storyblok-react'
import Image from 'gatsby-theme-kn/src/components/atoms/Image'
import Link from 'gatsby-theme-kn/src/components/atoms/Link'
import Headline from '../atoms/Headline'

import { useTranslation } from 'react-i18next'

const EnvironmentBlock = ({ block }) => {
  const { t } = useTranslation()
  return (
    <SbEditable content={block}>
      <section className="environment-block">
        <div className="environment-block-container">
          <Headline headline={t('product_page.environment_block.title')} />
          <div className="environment-block-awards">
            {block.awards?.map((item, index) => (
              <div className="environment-block-awards-item" key={index}>
                <div className="environment-block-awards-item-image">
                  <Image image={item.preview_url} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default EnvironmentBlock
